import { useEffect } from "react";

import type { EnvironmentId } from "@afar-research/contracts";

import { useEnvironments } from "../state/environments";
import { projectEnvironment } from "../state/projects";
import { useEnvironmentQuery } from "../state/query";
import { projectActionReadinessToast } from "./ProjectActionReadinessToast";
import { toastManager } from "./ui/toast";

function EnvironmentProjectActionReadinessToastCoordinator(props: {
  readonly environmentId: EnvironmentId;
}) {
  const latestEvent = useEnvironmentQuery(
    projectEnvironment.readinessEvents({ environmentId: props.environmentId, input: {} }),
  ).data;

  useEffect(() => {
    if (latestEvent === null) return;
    toastManager.add(projectActionReadinessToast(latestEvent));
  }, [latestEvent]);

  return null;
}

export function projectActionReadinessEnvironmentIds(
  environments: ReadonlyArray<{ readonly environmentId: EnvironmentId }>,
): ReadonlyArray<EnvironmentId> {
  return environments.map((environment) => environment.environmentId);
}

export function ProjectActionReadinessToastCoordinator() {
  const { environments } = useEnvironments();
  return projectActionReadinessEnvironmentIds(environments).map((environmentId) => (
    <EnvironmentProjectActionReadinessToastCoordinator
      key={environmentId}
      environmentId={environmentId}
    />
  ));
}
